import { createRoot } from "react-dom/client"
import { RenderComponentCallback } from "../types"

export default function renderComponent(
    identifier: string,
    callback: RenderComponentCallback
): void {
    const containers = Array.from(
        document.querySelectorAll(`[data-render-component="${identifier}"]`)
    ) as HTMLElement[]

    if (!containers || containers.length === 0 || !callback) {
        return
    }

    containers.forEach(container => {
        const dataset = { ...container.dataset }
        const root = createRoot(container)
        root.render(callback(dataset, container, root))
    })
}
